<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col overflow-auto mt-2">
          <div class="card h-100 bg-white shadow-sm rounded-5 border-0">
            <div class="card-header bg-white rounded-5 border-0">
                <div class="card-header border-0 bg-white rounded-5 d-flex justify-content-between align-items-center">
                    <!-- <span class="fw-500">Manage Questions</span> -->
                    <button
                      type="button"
                      class="btn btn-primary text-white text-xs rounded shadow-sm fw-500"
                      @click="toggle_personal_profile_responses"
                    >
                      {{ show_personal_profile_responses ? 'View Questions' : 'View Responses' }}
                    </button>
                  </div>

                <div v-if="!show_personal_profile_responses" class="assign-question-table-shell mt-3">
                  <div class="assign-question-table-header d-flex align-items-start justify-content-between gap-3 flex-wrap">
                    <div>
                      <p class="mb-1 fw-bold text-sm text-dark">Assign Questions</p>
                      <p class="mb-0 text-xxs text-muted">Choose which questions belong to this section.</p>
                    </div>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <span class="badge bg-light text-xs text-dark border rounded">{{ questionDetails.length }} Questions</span>
                      <span class="badge bg-light text-muted text-xs text-dark border rounded">{{ assigned_questions_count }} Assigned</span>
                    </div>
                  </div>

                  <div class="assign-question-table-body">
                    <div class="table-responsive">
                      <table id="questionsTable" class="table table-striped text-xxs align-middle mb-0">
                        <thead>
                          <tr>
                            <th scope="col" class="text-nowrap">No</th>
                            <th scope="col">Question</th>
                            <th scope="col" class="text-nowrap">Type</th>
                            <th scope="col" class="text-nowrap text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody class="text-black">
                          <tr v-for="(question, index) in questionDetails" :key="question.question_id">
                            <th scope="row" class="text-muted fw-semibold">{{ index + 1 }}</th>
                            <td class="fw-semibold text-dark">{{ question.question_name }}</td>
                            <td class="text-muted">{{ question.question_type }}</td>
                            <td class="text-center">
                              <input
                                class="form-check-input assign-question-checkbox"
                                type="checkbox"
                                :id="'question_check_' + question.question_id"
                                :checked="question.is_assigned_to_section"
                                :disabled="question.assigning"
                                @change="toggle_question_assignment(question, $event)"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              <div v-if="show_personal_profile_responses" class="bg-light border rounded p-3 mt-3">
                <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-3">
                  <div>
                    <p class="mb-1 fw-bold text-sm text-dark">Section Responses</p>
                  </div>
                </div>

                <div v-if="loading_personal_profile_forms" class="text-center py-5">
                  <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                  <p class="mb-0 mt-2 text-muted text-xxs">Loading responses...</p>
                </div>

                <div v-else-if="get_personal_profile_form_tables().length" class="d-grid gap-3">
                  <div
                    v-for="formTable in get_personal_profile_form_tables()"
                    :key="formTable.form.id"
                    class="card border-0 shadow-sm rounded"
                  >
                    <div class="card-header bg-white d-flex align-items-start justify-content-between gap-3 flex-wrap">
                      <div>
                        <p class="mb-3 fw-bold text-sm text-dark">{{ formTable.form.name }}</p>
                        <div class="d-flex align-items-center gap-2 flex-wrap mt-2">
                          <span class="badge bg-light text-dark border rounded">{{ formTable.rows.length }} Responses</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm btn-primary text-xs fw-500 rounded px-3"
                        @click="export_personal_profile_form_table(formTable)"
                      > Export CSV
                      </button>
                    </div>

                    <div class="card-body">
                      <div class="table-responsive">
                        <table
                          :id="`assign-profile-form-table-${formTable.form.id}`"
                          class="table table-sm table-bordered align-middle mb-0 bg-white assign-profile-form-table"
                        >
                          <thead class="table-light">
                            <tr>
                              <th class="text-xxs text-nowrap">User</th>
                              <th class="text-xxs text-nowrap">Email</th>
                              <th
                                v-for="question in formTable.questions"
                                :key="question.id"
                                class="text-xxs">
                                {{ question.question }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="row in formTable.rows"
                              :key="`${formTable.form.id}-${row.base_profile_id}`"
                            >
                              <td class="text-xs fw-semibold text-nowrap">{{ get_personal_profile_user_name(row.user) }}</td>
                              <td class="text-xs text-nowrap">{{ row.user?.email || '-' }}</td>
                              <td
                                v-for="question in formTable.questions"
                                :key="`${row.base_profile_id}-${question.id}`"
                                class="text-xs"
                              >
                                <div class="text-break">{{ get_personal_profile_answer_cell(row, question.id).text }}</div>
                                <div v-if="get_personal_profile_answer_cell(row, question.id).files.length" class="d-flex flex-column gap-1 mt-2">
                                  <a
                                    v-for="fileItem in get_personal_profile_answer_cell(row, question.id).files"
                                    :key="fileItem.id"
                                    :href="fileItem.file?.s3_url"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="text-xxs"
                                  >
                                    {{ fileItem.file?.name || 'Open file' }}
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else class="text-center text-muted py-5">
                  <i class="bi bi-inbox fs-3 d-block mb-2"></i>
                  <p class="mb-1 fw-semibold text-dark text-xs">No form responses yet</p>
                  <p class="mb-0 text-xxs">Submitted personal profile forms will appear here.</p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
